import type { ReactNode } from "react";
import { SeverityPill, type SeverityPillColor } from "../generic/components/severity-pill";
import type { ReviewStatus } from "../moment/server/supabase-moment-review-service";
import type { MomentStatus } from "./types";

const reviewStatusPills: Partial<
  Record<ReviewStatus, { color: SeverityPillColor; label: string }>
> = {
  IN_REVIEW: { color: "info", label: "in review" },
  APPROVED: { color: "success", label: "approved" },
  CHANGES_REQUESTED: { color: "error", label: "changes requested" },
  PUBLISHED: { color: "primary", label: "published" },
};

export const reviewStatusToPill = (reviewStatus: ReviewStatus): ReactNode => {
  const pill = reviewStatusPills[reviewStatus];

  return pill ? (
    <SeverityPill color={pill.color} data-testid={reviewStatus + "-pill"}>
      {pill.label}
    </SeverityPill>
  ) : null;
};

export const statusToPill = (
  status: MomentStatus,
  valueMap: { [_: string]: SeverityPillColor } = {
    draft: "warning",
    paused: "disabled",
    active: "error",
    finished: "info",
    archived: "disabled",
  },
): ReactNode => {
  return (
    <SeverityPill color={valueMap[status]!} data-testid={status + "-pill"}>
      {status}
    </SeverityPill>
  );
};
